const PatientDashboard = ()=>{
    return(
        <>
            <div>
                <br/>
                <br/>
                <br/>
                <h3>dashboard page of patient</h3>
            </div>
        </>
    )
}

export default PatientDashboard;